module.exports = __webpack_public_path__ + "static/img/img-about-1.913fcad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-1.png
// module id = mkxQ
// module chunks = 0